import type { AcademicYearSchema } from '@/types/academic_year_schema';

// Deliberately not persisted: a page reload must validate the saved candidate
// against the API again before sending it as an academic-year request header.
let verifiedSelection = { scope: '', id: '' };

export function academicYearContextScope(storage: Storage = localStorage): string {
  try {
    const school = JSON.parse(storage.getItem('school') || '{}');
    const branch = JSON.parse(storage.getItem('branch') || '{}');
    return school.id ? `${encodeURIComponent(String(school.id))}:${encodeURIComponent(String(branch.id || 'all'))}` : '';
  } catch { return ''; }
}

export const academicYearSelectionKey = (scope: string) => `academicYearSelection:${scope}`;

export function resolveAcademicYearSelection(years: AcademicYearSchema[], savedId: string | null) {
  return years.find(year => String(year.id) === savedId) || years.find(year => year.status === 'active') || null;
}

export function clearAcademicYearHeader(storage: Storage = localStorage) {
  verifiedSelection = { scope: '', id: '' };
  storage.removeItem('selectedAcademicYear');
  storage.removeItem('selectedAcademicYearScope');
}

export function setValidatedAcademicYearHeader(year: AcademicYearSchema, scope: string, storage: Storage = localStorage) {
  if (!year.id || !scope || scope !== academicYearContextScope(storage)) return;
  verifiedSelection = { scope, id: String(year.id) };
  storage.setItem('selectedAcademicYear', JSON.stringify(year));
  storage.setItem('selectedAcademicYearScope', scope);
}

export function selectedAcademicYearRequestId(storage: Storage = localStorage): string {
  const scope = academicYearContextScope(storage);
  if (!scope || verifiedSelection.scope !== scope || storage.getItem('selectedAcademicYearScope') !== scope) return '';
  try {
    const storedId = String(JSON.parse(storage.getItem('selectedAcademicYear') || '{}').id || '');
    return storedId === verifiedSelection.id ? storedId : '';
  }
  catch { return ''; }
}
